function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPeopleMyPageRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M29.615 28.325a18.55 18.55 0 00-.415-2.267 1.875 1.875 0 00-.59-.975 14.82 14.82 0 00-3.905-2.275 1.585 1.585 0 01-.957-1.115 1.559 1.559 0 01.392-1.414c1.06-1.126 1.327-1.776 1.327-4.529 0-3.019-1.582-4.75-4.341-4.75-2.76 0-4.34 1.731-4.34 4.75 0 2.753.266 3.403 1.326 4.529a1.558 1.558 0 01-.565 2.529 14.82 14.82 0 00-3.905 2.275c-.293.256-.5.597-.59.975a18.57 18.57 0 00-.416 2.267A1.51 1.51 0 0014.151 30H28.1a1.51 1.51 0 001.514-1.675z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.785 15.75c0-4.1 2.489-6.75 6.34-6.75a7.8 7.8 0 01.875.053V4a2 2 0 00-2-2H4a2 2 0 00-2 2v18a2 2 0 002 2h7.91c.133-.157.277-.304.433-.438a16.34 16.34 0 013.901-2.375c-1.236-1.485-1.459-2.773-1.459-5.437zM6 7h10v2H6V7zm4 10H6v-2h4v2zm3-4H6v-2h7v2z",
    fill: props.color
  }));
}

export default SvgIconPeopleMyPageRexFilled;